import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagAgenteRetencionFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagAgenteRetencion'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagAgenteRetencion'
          label='Es agente de reteción'
        />
      )}
    </Field>
  )
}

export default FlagAgenteRetencionFormGroup
